import styled, { css } from 'styled-components';

const Button = styled.button`
  font-family: 'Roboto Condensed',sans-serif;
  display: inline-block;
  background-color: ${props => props.theme.colors.lightGray};
  font-weight: 600;
  padding: 10px 15px;
  text-transform: uppercase;
  border-radius: ${props => props.theme.borderRadius};

  ${props =>
    props.large &&
    css`
      padding: 20px 40px;
    `}

  ${props =>
    props.small &&
    css`
      padding: 8px;
      font-size: 12px;
    `}

  ${props =>
    props.primary &&
    css`
      background: ${props.theme.colors.primary};
      color: ${props.theme.colors.white};

      &:hover,
      &:focus {
        background: ${props.theme.colors.secondary};
      }
    `}

  ${props =>
    props.danger &&
    css`
      background: ${props.theme.colors.alert};
      color: ${props.theme.colors.white};

      &:hover,
      &:focus {
        background: ${props.theme.colors.alertFocus};
      }
    `}

  ${props =>
    props.alert &&
    css`
      background: ${props.theme.colors.alert};
      color: ${props.theme.colors.white};

      &:hover,
      &:focus {
        background: ${props.theme.colors.alertFocus};
      }
    `}

  ${props =>
    props.success &&
    css`
      background: ${props.theme.colors.success};
      color: ${props.theme.colors.white};

      &:hover,
      &:focus {
        background: ${props.theme.colors.successFocus};
      }
    `}


  ${props =>
    props.close &&
    css`
      display: block;

      box-sizing: content-box;
      width: 16px;
      height: 16px;
      background: transparent
        url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e")
        center/16px auto no-repeat;
      color: ${props.theme.fontColor};

      @media (max-width: ${props.theme.breakpoints.lg}) {
        background-size: 22px;
        width: 22px;
        height: 22px;
      }

      @media (min-width: ${props.theme.breakpoints.lgUp}) {
        width: 16px;
        height: 16px;
      }

      &:hover,
      &:focus {
        opacity: 0.6;
      }
    `}

  ${props =>
    props.expanded &&
    css`
      width: 100%;
    `}

  ${props =>
    props.asLink &&
    css`
      display: inline-flex;
      align-items: center;
      margin: 0;
      padding: 0;
      background-color: transparent;
    `}

  ${props =>
    props.remove &&
    css`
      width: 40px;
      height: 30px;
      margin: 2px 5px;
      background-color: ${props.theme.colors.secondary};
      background-image: url('data:image/svg+xml;utf8,<svg height="512pt" fill="white" viewBox="-47 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg"><path d="m416.875 114.441406-11.304688-33.886718c-4.304687-12.90625-16.339843-21.578126-29.941406-21.578126h-95.011718v-30.933593c0-15.460938-12.570313-28.042969-28.027344-28.042969h-87.007813c-15.453125 0-28.027343 12.582031-28.027343 28.042969v30.933593h-95.007813c-13.605469 0-25.640625 8.671876-29.945313 21.578126l-11.304687 33.886718c-2.574219 7.714844-1.2695312 16.257813 3.484375 22.855469 4.753906 6.597656 12.445312 10.539063 20.578125 10.539063h11.816406l26.007813 321.605468c1.933594 23.863282 22.183594 42.558594 46.109375 42.558594h204.863281c23.921875 0 44.175781-18.695312 46.105469-42.5625l26.007812-321.601562h6.542969c8.132812 0 15.824219-3.941407 20.578125-10.535157 4.753906-6.597656 6.058594-15.144531 3.484375-22.859375zm-249.320312-84.441406h83.0625v28.976562h-83.0625zm162.804687 437.019531c-.679687 8.402344-7.796875 14.980469-16.203125 14.980469h-204.863281c-8.40625 0-15.523438-6.578125-16.203125-14.980469l-25.816406-319.183593h288.898437zm-298.566406-349.183593 9.269531-27.789063c.210938-.640625.808594-1.070313 1.484375-1.070313h333.082031c.675782 0 1.269532.429688 1.484375 1.070313l9.269531 27.789063zm0 0"/><path d="m282.515625 465.957031c.265625.015625.527344.019531.792969.019531 7.925781 0 14.550781-6.210937 14.964844-14.21875l14.085937-270.398437c.429687-8.273437-5.929687-15.332031-14.199219-15.761719-8.292968-.441406-15.328125 5.925782-15.761718 14.199219l-14.082032 270.398437c-.429687 8.273438 5.925782 15.332032 14.199219 15.761719zm0 0"/><path d="m120.566406 451.792969c.4375 7.996093 7.054688 14.183593 14.964844 14.183593.273438 0 .554688-.007812.832031-.023437 8.269531-.449219 14.609375-7.519531 14.160157-15.792969l-14.753907-270.398437c-.449219-8.273438-7.519531-14.613281-15.792969-14.160157-8.269531.449219-14.609374 7.519532-14.160156 15.792969zm0 0"/><path d="m209.253906 465.976562c8.285156 0 15-6.714843 15-15v-270.398437c0-8.285156-6.714844-15-15-15s-15 6.714844-15 15v270.398437c0 8.285157 6.714844 15 15 15zm0 0"/></svg>');
      background-position: 50%;
      background-size: 16px 16px;
      background-repeat: no-repeat;

      &:hover,
      &:focus {
        background-color: ${props.theme.colors.secondaryDark};
      }
    `}

  ${props =>
    props.confirm &&
    css`
      width: 40px;
      height: 30px;
      margin: 2px 5px;
      background-color: ${props.theme.colors.success};
      background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='iso-8859-1'%3F%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 511.999 511.999' xml:space='preserve'%3E%3Cg%3E%3Cpath fill='white' d='M506.231,75.508c-7.689-7.69-20.158-7.69-27.849,0l-319.21,319.211L33.617,269.163c-7.689-7.691-20.158-7.691-27.849,0 c-7.69,7.69-7.69,20.158,0,27.849l139.481,139.481c7.687,7.687,20.16,7.689,27.849,0l333.133-333.136 C513.921,95.666,513.921,83.198,506.231,75.508z'/%3E%3C/g%3E%3C/svg%3E%0A");
      background-position: 50%;
      background-size: 16px 16px;
      background-repeat: no-repeat;

      &:hover,
      &:focus {
        background-color: ${props.theme.colors.successFocus};
      }
    `}

  &[disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export { Button };
